import { log } from '@frameio/utils';

export const imageUploadClient = async (
  uploadUrl: string,
  blob: Blob,
  cb: (res: Response) => void
) => {
  const signedUrlResponse = await fetch(uploadUrl, {
    method: 'put',
    body: blob,
    headers: {
      'Content-Type': blob.type,
      'x-amz-acl': 'private',
    },
  })
    .then((res) => cb(res))
    .catch((err) => {
      log.error('Failed to upload blob to storage: ', err);
    });

  return signedUrlResponse;
};
